import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { BriefingPage } from './pages/BriefingPage';
import { LanguageProvider } from './i18n/LanguageContext';
const GA_ID = 'G-HZZZP0GQTN';
export function App() {
  useEffect(() => {
    // Inject gtag.js script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script1);
    // Inject gtag config script
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;
    document.head.appendChild(script2);
  }, []);
  return <LanguageProvider data-id="element-0" data-mp="3ijxpcqos80jw">
      <BrowserRouter data-id="element-1" data-mp="3ikhaeg9qb525">
        <div className="min-h-screen bg-[#0a1628] text-white selection:bg-[#38bdf8] selection:text-[#0a1628]" data-id="element-2" data-mp="3iiwasc8k4vxf">
          <Navbar data-id="element-3" data-mp="3mjzs7369700r" />
          <main data-id="element-4" data-mp="3mjga9mglsbmq">
            <Routes data-id="element-5" data-mp="3rc9du70c5dx8">
              <Route path="/" element={<HomePage data-id="element-7" data-mp="3rdki07xp0nov" />} data-id="element-6" data-mp="3rbrbcsn2y3gv" />
              <Route path="/briefing" element={<BriefingPage data-id="element-9" data-mp="5or2zhbcs60" />} data-id="element-8" data-mp="3recf5n6xuth9" />
            </Routes>
          </main>
          <Footer data-id="element-10" data-mp="82jt1oitsae" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}